goog.module('yext.developerapps.inquicker.InQuickerApiKeyConfiguration');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.developerapps.routes');
const Field = goog.require('yext.developerapps.inquicker.Field');

const InQuickerApiKeyConfiguration = class
  extends Field {
  constructor() {
    super($('.js-inquicker-api-key-container'));
  }

  /** @override */
  doSubmit_(data) {
    return $.ajax({
      method: 'POST',
      url: routes.InQuicker.saveApiKey(),
      data: data,
    })
      .done(function(resp) {
        if (resp['success']) {
          window.location.href = routes.InQuicker.apiKey();
        } else {
          this.handleErrors_(resp['errors']);
        }
      }.bind(this));
  }

  static init() {
    new InQuickerApiKeyConfiguration();
  }
};

goog.exportSymbol('yext.developerapps.inquicker.InQuickerApiKeyConfiguration.init',
  InQuickerApiKeyConfiguration.init);

exports = InQuickerApiKeyConfiguration;
